module.exports = __webpack_public_path__ + "static/icon10-bcfe643a00680ed199e9b096b121fa74.svg";